import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/maiscontrole-obras/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/maiscontrole-obras/delete`,
        endpoint: `${endpointBackend}gci/maiscontrole-obras/getall`
    }

    let list = {
        labelTitle: 'Mais Controle - Obras',
        fieldsShowOnDelete: ['nome'],
        canAdd: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'nome',
                label: 'Obra',
                width: '30%'
            },
            {
                name: 'status_obra',
                label: 'Status da Obra'
            },
            {
                name: 'codigo_obra',
                label: 'Código da Obra'
            },
            {
                name: 'tipo_obra',
                label: 'Tipo de Obra'
            },
            {
                name: 'responsavel_obra',
                label: 'Responsável da Obra',
                width: '20%'
            },
            {
                name: 'responsavel_tecnico',
                label: 'Responsável Técnico',
                width: '20%'
            },
            {
                name: 'area_total',
                label: 'Área Total'
            },
            {
                name: 'unidade_area_total',
                label: 'Unidade de Área Total'
            },
            {
                name: 'cliente',
                label: 'Cliente',
                width: '30%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
